import { z } from 'zod';
import { BIOME_IDS } from '../data/biomes.js';
import { ENCOUNTER_KINDS } from '../data/encounters.js';
/**
 * Road encounters (ADR 0093). The client names an encounter and nothing
 * else: the server knows where it stands, what the peddler carries, who
 * already bought or opened, and pays.
 */
const EncounterIdSchema = z.string().regex(/^enc-\d{1,9}$/);
/** Buy the peddler's lot, whole. */
export const PeddlerBuyMessageSchema = z.object({ encounterId: EncounterIdSchema });
/** Open a lost chest on the road. */
export const EncounterOpenMessageSchema = z.object({ encounterId: EncounterIdSchema });
const LotSchema = z.object({
    templateId: z.string().min(1),
    quantity: z.number().int().min(1),
});
/** One encounter on the roads, as one player sees it. */
export const EncounterViewSchema = z.object({
    id: EncounterIdSchema,
    kind: z.enum(ENCOUNTER_KINDS),
    biome: z.enum(BIOME_IDS),
    x: z.number().int().min(0),
    y: z.number().int().min(0),
    /** Until it leaves the road. */
    remainingMs: z.number().int().min(0),
    /** The peddler's lot and its price for the whole lot. */
    ware: LotSchema.extend({ price: z.number().int().min(1) }).optional(),
    /** This player bought from the peddler, or opened the chest: nothing more for them. */
    done: z.boolean().default(false),
    /** The traveller's raiders still standing. */
    raiders: z.number().int().min(0).optional(),
});
/** To each player of the world zone, on joining and whenever one comes, changes or goes. */
export const EncountersEventSchema = z.object({ encounters: z.array(EncounterViewSchema).max(8) });
/** To the buyer, after the purchase; the new inventory, gold included, follows. */
export const PeddlerBoughtSchema = LotSchema.extend({
    encounterId: EncounterIdSchema,
    gold: z.number().int().min(0),
});
/** To the opener: what fell out, on the road in front, to be picked up. */
export const EncounterChestOpenedSchema = z.object({
    encounterId: EncounterIdSchema,
    items: z.array(LotSchema),
});
/** To each rescuer as the last raider falls: the experience, and what lies at their feet. */
export const EncounterRescuedSchema = z.object({
    encounterId: EncounterIdSchema,
    xp: z.number().int().min(0),
    items: z.array(LotSchema),
});
export const ENCOUNTER_REFUSALS = [
    'invalid',
    'unknown',
    'too-far',
    'dead',
    'sold-out',
    'opened',
    'missing-gold',
    'bag-full',
    /** Something went wrong on the server: nothing was spent, try again. */
    'failed',
];
export const EncounterRejectedSchema = z.object({
    encounterId: EncounterIdSchema.optional(),
    reason: z.enum(ENCOUNTER_REFUSALS),
});
//# sourceMappingURL=encounters.js.map